module.exports = __webpack_public_path__ + "media/images/map-icons/carA@2x-9269d32dbb78bd89fdb5ae9651f1a233.png";